import { Box, Stack, Typography, styled } from "@mui/material";

const RootStyle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  backgroundColor: '#00AB55',
  width: 4,
  height: 16
});


function SectionHeader({ title, ...props }) {

  return (
    <Stack direction='row' alignItems="center" gap={1} {...props}>
      <RootStyle></RootStyle>
      <Typography fontWeight='bold'>{title}</Typography>
    </Stack>
  )
}

export default SectionHeader;